import axios from 'axios'

const state = {
  albums: []
}

const getters = {
  albums: (state) => state.albums,
  albumById: (state) => (id) => state.albums.find((a) => String(a.id) === String(id))
}

const mutations = {
  setAlbums (state, albums) {
    state.albums = Array.isArray(albums) ? albums : []
  },

  addAlbum (state, album) {
    state.albums.push(album)
  },

  updateAlbum (state, payload) {
    const index = state.albums.findIndex((a) => String(a.id) === String(payload.id))
    if (index === -1) return
    if (payload.name !== undefined) state.albums[index].name = payload.name
    if (payload.nameEn !== undefined) state.albums[index].nameEn = payload.nameEn
    if (payload.images !== undefined) state.albums[index].images = payload.images
  },

  removeAlbum (state, id) {
    const index = state.albums.findIndex((a) => String(a.id) === String(id))
    if (index !== -1) state.albums.splice(index, 1)
  }
}

function normalizeAlbumImage (img) {
  const url = img.image || img.url
  const description = img.description || ''
  const link = img.link || ''
  return { url, description, link }
}

const actions = {
  async load ({ commit }) {
    try {
      const { data } = await axios.get('/api/galleries')
      const list = (data && data.data) ? data.data : []
      commit('setAlbums', list.map((a) => ({
        id: a.id,
        name: a.name,
        nameEn: a.name_en != null ? a.name_en : '',
        images: Array.isArray(a.images) ? a.images.map(normalizeAlbumImage) : []
      })))
    } catch (e) {
      return Promise.reject(e)
    }
  },

  async createAlbum ({ commit }, { name, nameEn }) {
    const form = new FormData()
    form.append('name', (name || '').trim())
    if (nameEn != null) form.append('name_en', (nameEn || '').trim())
    const { data } = await axios.post('/api/gallery', form)
    const album = data.data
    const normalized = {
      id: album.id,
      name: album.name,
      nameEn: album.name_en != null ? album.name_en : '',
      images: Array.isArray(album.images) ? album.images.map(normalizeAlbumImage) : []
    }
    commit('addAlbum', normalized)
    return normalized
  },

  async createAlbumFromEdit ({ dispatch }, { name, nameEn }) {
    return dispatch('createAlbum', { name, nameEn })
  },

  async uploadGalleryImage (_, file) {
    const form = new FormData()
    form.append('image', file)
    const { data } = await axios.post('/api/gallery/upload', form)
    if (!data || data.path == null) return Promise.reject(new Error('Upload failed'))
    return data.path
  },

  async updateAlbum ({ commit }, { id, name, nameEn, images }) {
    const oldImages = (images || []).map((img) => ({
      image: img.url || img.image || '',
      description: img.description || '',
      link: img.link || ''
    }))
    const payload = {
      name: (name || '').trim(),
      oldImages
    }
    if (nameEn !== undefined) payload.name_en = (nameEn || '').trim()
    const { data } = await axios.post(`/api/gallery/${id}`, payload)
    const album = data.data
    const normalized = {
      id: album.id,
      name: album.name,
      nameEn: album.name_en != null ? album.name_en : '',
      images: Array.isArray(album.images) ? album.images.map(normalizeAlbumImage) : []
    }
    commit('updateAlbum', { id, name: normalized.name, nameEn: normalized.nameEn, images: normalized.images })
    return normalized
  },

  async deleteAlbum ({ commit }, id) {
    await axios.delete(`/api/gallery/${id}`)
    commit('removeAlbum', id)
  },

  async reorderAlbums ({ commit }, ids) {
    await axios.put('/api/galleries/reorder', { ids })
    const { data } = await axios.get('/api/galleries')
    const list = (data && data.data) ? data.data : []
    commit('setAlbums', list.map((a) => ({
      id: a.id,
      name: a.name,
      nameEn: a.name_en != null ? a.name_en : '',
      images: Array.isArray(a.images) ? a.images.map(normalizeAlbumImage) : []
    })))
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
